import React, {useEffect, useState} from "react";
import "../OnlineOrderDetail/OnlineOrderDetail.scss";
import {useHistory, useParams} from "react-router-dom";
import {ConvertToJalali, FactorData} from "../StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import {StoreOnlinePaymentVerify} from "../Payment/PaymentService";


const _verify = {
    "rewards": [],
    "payment_transaction": {
        "invoice_uid": "",
        "gateway": {
            "title": "",
            "image": ""
        },
        "amount": null,
        "reference_number": "",
        "is_successful": false,
        "is_verified": false
    },
    "invoice": {
        "id": 5566,
        "uid": "THTq5oH8c6",
        "user": {
            "uid": "kmVrnxT4fL",
            "phone": "09363565238",
            "first_name": "رضا",
            "last_name": "مزارلو",
            "image": null,
            "email": "",
            "gender": "male",
            "birthday_date": null
        },
        "merchant": {
            "uid": "ZDegRfpazn",
            "name": "کافه شمرون - پارک گفتگو",
            "subtitle": null,
            "mall_uid": "XWMZPkGyte",
            "mall_name": "کافه شمرون",
            "payment_sdk_client_id": null,
            "description": "تراس کافه‌شمرون بوستان گفتگو با سقفی که آسمونه، کنار دریاچه با منظره پر از درخت \r\n\r\nاگر دلتون یه دورهمی تو فضای باز رو می‌خواد،\r\n یا که دوست دارید جایی کنار آب و ماهی‌های گلی، وسط یه حیاط پر درخت وقت بگذرونید\r\nتو کافه شمرون بوستان گفتگو منتظرتون هستیم.",
            "image": "https://s3.mobank.co/loyalty-media/merchant/merchant/images/large_pic_ZkckqG7_A8w4hDR.png",
            "floor_uid": null,
            "unit": null,
            "thumbnail": "https://s3.mobank.co/loyalty-media/merchant/merchant/images/logo-goftogoo-1_xdE76sp.png",
            "cover": "https://s3.mobank.co/loyalty-media/merchant/merchant/images/cover_dwOPQ03-min_Cngwue4.jpg",
            "order": 4,
            "is_featured": true,
            "categories": [
                {
                    "uid": "d7C7afsPf7",
                    "title": "کافه"
                },
                {
                    "uid": "fBRSjyMboF",
                    "title": "رستوران"
                }
            ],
            "map_image": null,
            "marker": "https://s3.mobank.co/loyalty-media/merchant/marker/icon/Gv3u8GgFS7.png",
            "phone": "02188230930",
            "hours": "9 تا 24",
            "address": "تهران، گیشا، انتهای خیابان پیروزی شرقی، ضلع شمالی بوستان گفتگو، مجموعه پذیرایی گفتگو",
            "website": "http://cafeshemroon.com",
            "wallet_id": null,
            "tags": [],
            "created": "2020-10-07T16:10:26.241001+03:30",
            "type": "merchant",
            "acceptor": "304f6221015947b4991a28ea74c40977",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    51.3819623,
                    35.7375291,
                    0,
                    null
                ]
            },
            "online_merchant": false
        },
        "order": {
            "uid": "JCYv53b8Xb",
            "status": 3,
            "status_label": "finalize_by_user",
            "amount": 10000.0,
            "original_amount": 10000,
            "discount": 0,
            "description": null,
            "items": [
                {
                    "uid": "AqcwkyHDNA",
                    "name": "نان و پنیر و گردو",
                    "quantity": 1,
                    "per_amount": 10000,
                    "amount": 10000,
                    "product_id": 110738,
                    "product": {
                        "uid": "MA6KZ9Fazf",
                        "name": "نان و پنیر و گردو",
                        "price_original": 10000,
                        "price": 10000,
                        "stock": 10,
                        "is_available": true,
                        "image": "https://s3.mobank.co/loyalty-media/product/product/images/gerdoo.jpg"
                    },
                    "per_discount": 0,
                    "discount": 0,
                    "original_amount": 10000,
                    "is_canceled": false,
                    "pay_status": 2,
                    "picked_quantity": 0
                }
            ]
        },
        "coupon": null,
        "amount": 10000,
        "discount_amount": 0,
        "payable_amount": 10000,
        "state": "success_to_pay",
        "paid_at": "2020-12-28T12:02:05.466204+03:30",
        "purchase_token": "10425966f414b888a94a536cb01b4c875299",
        "description": null,
        "calculation_log": [],
        "created": "2020-12-28 10:10:58.923853+00:00"
    }
}



function InvoiceDetail() {

    const { id } = useParams();
    const history = useHistory();


    const [factor,set_factor] = useState(null)
    const [verify,set_verify] = useState(null)
    const [empty,set_empty] = useState(false)
    const [status,set_status] = useState(null)
    const [message,set_message] = useState("")
    const [sign,set_sign] = useState("")

    useEffect(()=>{
        console.log("id" , id)
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const status = params.get('status');
        const message = params.get('message');
        const sign = params.get('sign');
        if(status){set_status(status)}
        if(message){set_message(message)}
        if(sign){set_sign(sign)}
        getFactorDetail(id)
    },[])



    const numberWithCommas = (x) => {
        if (x === 0) {
            return 0
        }
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    const getFactorDetail = async (id) => {
        try {
            const response = await FactorData(id);
            let res= response.data;
            res['order'] = []
            res['order']['items'] = response.data.products
            set_verify({invoice:res});
            return true;
        } catch (e) {
            // console.log(e)
            set_empty(true)
            return false;
        }
    }

    return(
        <div className="online-detail-container-order">
            {verify?            <>
                <div className="online-detail-cover">
                    <img src={verify.invoice.merchant.cover} alt=""/>
                </div>

                {/*Info*/}
                <div className="storeDetail-info">
                    <div className="storeDetail-info-name">
                        <span className="storeDetail-info-name-title">{verify.invoice.merchant && verify.invoice.merchant.name}</span>
                        <span className="storeDetail-info-name-point">خرید شما از این فروشگاه می باشد</span>
                    </div>
                    <div className="storeDetail-info-logo">
                        <img src={verify.invoice.merchant && verify.invoice.merchant.thumbnail} alt=""/>
                    </div>
                </div>

                {/*{status?<div className="detail-status-success">*/}
                {/*    <span>{message}</span>*/}
                {/*</div>:null}*/}


                <div className="factor-header">
                    <div className="factor-header-item left">
                        <span className="factor-header-item-title">تاریخ</span>
                        {verify.invoice.created ?
                            <span className="factor-header-item-val">{ConvertToJalali(verify.invoice.created)}</span> : null}
                    </div>
                    <div className="factor-header-item right">
                        <span className="factor-header-item-title">شماره فاکتور</span>
                        {verify.invoice.uid ? <span className="factor-header-item-val">{verify.invoice.uid}</span> : null}
                    </div>
                </div>

                <div className="factor-table" style={{paddingBottom:120}}>
                    <table>
                        <thead>
                        <tr>
                            <th className="product-table-head">جمع کل</th>
                            {/*<th className="product-table-head">تخفیف</th>*/}
                            <th className="product-table-head">تعداد</th>
                            <th className="product-table-head product-table-head-name">نام کالا</th>
                            <th className="product-table-head product-table-head-name">تصویر</th>
                        </tr>
                        </thead>
                        <tbody>
                        {verify.invoice && verify.invoice.order && verify.invoice.order.items.map(product => {
                            return (
                                <tr key={product.uid}>
                                    <td className="product-price">{numberWithCommas(product.amount)}</td>
                                    {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                    <td className="product-count">{product.quantity}</td>
                                    <td className="product-name">{product.name}</td>
                                    <td className="product-name">
                                        {product.product?<img src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"} alt=""/>:null}
                                    </td>
                                </tr>
                            )
                        })
                        }
                        </tbody>
                    </table>

                    <div className="factor-table-total-row customer_discount-row">
                        <div className="factor-table-total--price customer_discount-val">
                            <span>ریال</span>
                            {<span>{numberWithCommas(verify.invoice.discount_amount)}</span>}
                        </div>
                        <span className="customer_discount"> : تخفیف  </span>
                    </div>

                    <div className="factor-table-total-row">
                        <div className="factor-table-total--price">
                            <span>ریال</span>
                            {verify.invoice.payable_amount ? <span>{numberWithCommas(verify.invoice.payable_amount)}</span> : null}
                        </div>
                        <span> : جمع کل  </span>
                    </div>
                </div>
            </> :null}

            {empty?<div className="online-detail-empty">
                هیچ سفارشی با این شماره یافت نشد
            </div>:null}
            <div className="detail-float-btn-container-order">
                <div className="detail-float-btn-order" onClick={()=>{
                    history.goBack()
                }}>
                    <span>بازگشت</span>
                </div>
            </div>
        </div>
    )
}

export {InvoiceDetail};
